import {useEffect, useState} from "react";
import {CountdownCircleTimer} from "react-countdown-circle-timer";
import { UseRequest } from "../../hooks/UseRequest";
import UseDelete from "../../hooks/UseDelete";
import "./Loading.scss"

const Loading = (props) => {

    const [progress, setProgress] = useState(0)
    const [idProcess, setIdProcess] = useState(undefined)
    const [frequency, setFrequency] = useState(1)


    const mustShowProgress = props.showProgress || false
    const CountDownColors = ['#0d6efd', '#0d6efd', '#0d6efd', '#0d6efd']


    useEffect(() => {
        if (props && props.checkProgress) {
            setIdProcess(props.checkProgress.request.data._id)
        }
    }, [])


    const onStop = () => {
        if (typeof props.onStop == "function") {
            props.onStop()
        }
    }


    const StopProcess = async () => {
        await UseDelete(`${process.env.REACT_APP_BASE_API}/processes/delete/`, [idProcess], null,  onStop, null, null, true)
    }

    const getPercent = (currentStep, totalSteps) => {
        return Math.ceil((currentStep * 100) / totalSteps)
    }


    const updateCountDown = (counter) => {
        if (counter == 0) {
            UseRequest(props.checkProgress.url, {request: props.checkProgress.request}
            ).then(async (response) => {
                const data = await response.json()
                const process = data.entities[0]


                const current = parseInt(process.current_step)
                const total = parseInt(process.total_steps)

                if (current > 0 && total > 0) {
                    const newPercent = getPercent(current, total)
                    setProgress(newPercent)
                    if(newPercent == 100){
                        stopCountDown()
                    }
                }
            })
        }
    }


    const completeCountDown = () => {
        return {shouldRepeat: true, delay: 0}
    }


    const stopCountDown = async () => {
        return await StopProcess()
    }


    const CountDown = {
        size: 30,
        duration: frequency,
        strokeWidth: 4,
        isPlaying: true,
        colors: CountDownColors,
        colorsTime: [7, 5, 2, 0],
        onUpdate: updateCountDown,
        onComplete: completeCountDown,
    }


    const CountDownStop = {
        className: 'CountDownStop',
        'data-tip': 'Stop process',
        onClick: stopCountDown
    }


    return (
        <div className="Loading d-flex align-items-center justify-content-center">
            {
                !mustShowProgress && <div className="text-center">
                    <div className="spinner-border text-primary" role="status">
                    </div>
                    <span className="d-block">Loading, please wait</span>
                </div>
            }


            {
                mustShowProgress && <div className="ProgressContainer">
                    <div className="CountDown">
                        <span {...CountDownStop}>x</span>
                        <CountdownCircleTimer {...CountDown}>

                        </CountdownCircleTimer>
                    </div>
                    <div className="progress">
                        <div className="progress-bar" role="progressbar" style={{width: `${progress}%`}} aria-valuenow={progress} aria-valuemin="0" aria-valuemax="100">
                            {progress}%
                        </div>
                    </div>
                </div>
            }
        </div>
    )
}

export default Loading;